import PropTypes from 'prop-types';
import { memo } from 'react';
import styled from 'styled-components';

/**
 * CloseButton - An "X" to close modals, styled as the modal title next to it.
 * Props:
 *   - closeFn: function to call when button is clicked
 *   - closeCallback: optional callback passed to closeFn
 *   - ariaLabel: optional string for accessibility (default: "Close")
 *   - className: optional string for custom styling
 *   - style: optional inline style object
 */

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: inherit; // ModalHeader's colour, so the X matches its title
  font: inherit; // and its family, size and weight
  line-height: 1;
  cursor: pointer;
  padding: 0;
  box-sizing: border-box;
  margin: 4px;
  &:hover {
    opacity: 0.7;
  }
`;

// eslint-disable-next-line react/display-name
export const XButton = memo(({ closeFn, closeCallback, ariaLabel = 'Close', className = '', style = {} }) => (
  <CloseBtn type="button" onClick={() => closeFn && closeFn(closeCallback)} aria-label={ariaLabel} className={className} style={style}>
    X
  </CloseBtn>
));

XButton.propTypes = {
  closeFn: PropTypes.func.isRequired,
  closeCallback: PropTypes.any,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};

export default XButton;
